export default "__VITE_ASSET__Em7I4Gg3__"